import React, { useEffect } from 'react'
import { LeftSection, RightSection, SavingsHeader, SavingsWrapper } from '../savingsStage/SavingsStage.styles'

export const AutomaticDebiting = () => {
  
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <SavingsWrapper>
    <SavingsHeader>
          <LeftSection>
          <h3>
              This enables an automatic debiting of a fixed amount of money 
              as set by the user from a user's debit card.
          </h3>
          </LeftSection>
          <RightSection>
              <img src="img/Group 8615.svg" alt="couple saving in a bottle" />
          </RightSection>
      </SavingsHeader>
      </SavingsWrapper>
  )
}
